import gql from "graphql-tag";

const uploadImagesProjectMutation = gql`
  mutation uploadImageProject($file: Upload!) {
    uploadImageProject(image: $file) {
      path
    }
  }
`;

export default uploadImagesProjectMutation;